export enum ComponentType {
  NONE = "none",
  CRM_SYNC = "crm_sync",
  NEWSLETTER_SYNC = "newsletter_sync",
  YANOVIS = "yanovis",
  LTS_TICKETING = "lts_ticketing",
  DISCOUNT_CODE = "discount_code",
  LTS_ASTAT = "lts_astat",
  REST_API = "rest_api",
  VOUCHER = "voucher",
  LTS_SUEDTIROL_GUEST_PASS = "lts_suedtirol_guest_pass",
}

export enum ComponentTypeParameter {
  CRM_SYNC = "crmSync",
  NEWSLETTER_SYNC = "newsletterSync",
  YANOVIS = "yanovis",
  LTS_TICKETING = "ltsTicketing",
  DISCOUNT_CODE = "discountCode",
  LTS_ASTAT = "ltsAstat",
  REST_API = "rest_api",
  VOUCHER = "voucher",
  LTS_SUEDTIROL_GUEST_PASS = "ltsSuedtirolGuestPass",
}
